import { ChangeDetectionStrategy, Component, HostListener, Input, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { SectionData, SectionDataDb, SubSectionData } from 'src/app/model/help';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { HelperAddSectionDialogComponent } from '../helper-add-section-dialog/helper-add-section.dialog.component';
import { Observable, Subscription } from 'rxjs';
import * as HelpActions from 'src/app/store/help/help.actions';
import { HelperAddRowDialogComponent } from '../helper-add-row-dialog/helper-add-row.dialog.component';
import { HelperAddSubSectionDialogComponent } from '../helper-add-subsection-dialog/helper-add-subsection.dialog.component';
import { ConfirmationService } from 'primeng/api';
import { HelperOrderRowDialogComponent } from '../helper-order-row-dialog/helper-order-row.dialog.component';
import { HelperOrderSubSectionDialogComponent } from '../helper-order-subsection-dialog/helper-order-subsection.dialog.component';

@Component({
	selector: 'app-helper-section',
	templateUrl: './helper-section.component.html',
	changeDetection: ChangeDetectionStrategy.Default,
	providers: [ConfirmationService, DialogService]
})

export class HelperSectionComponent implements OnInit {
	@Input() section: SectionData;
	@Input() controller: boolean;

	sectionCurrent$: Observable<SectionDataDb | undefined>;
	sectionCurrentSub: Subscription | undefined;

	sectionData: SectionData;

	// Observables and subscriptions
	ref: DynamicDialogRef | undefined;

	keySection: string;
	keySubSection: string;

	acceptButtonStyle: string;
	rejectButtonStyle: string;

	// Design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	MAX_MD_WIDTH = 1120;

	constructor(
		private store: Store<AppState>,
		public dialogService: DialogService,
		private translate: TranslateService,
		public confirmationService: ConfirmationService,
	) {
	}

	ngOnInit() {
		this.sectionData = this.section;
		this.keySection = this.translate.instant('KEY_SECTION')+ ": ";
		this.keySubSection = this.translate.instant('KEY_SUBSECTION') + ": ";

		this.onResize();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onMobile(): boolean {
		return (this.screenWidth <= this.MIN_MD_WIDTH);
  	}

	col12Action() : string {
		return (this.screenWidth <= this.MIN_MD_WIDTH) ? "col-12" : "";
	}

	col12Responsive() : string {
		return (this.screenWidth <= this.MIN_MD_WIDTH) ? "col-12" : "col-6";
	}

	gridResp() : string {
		return (this.screenWidth <= this.MIN_MD_WIDTH) ? "grid flex w-full" : "";
	}

	// Actions Card Buttons
	modificaSezione(): void {
		this.ref = this.dialogService.open(HelperAddSectionDialogComponent, {
			header: this.translate.instant('EDIT_SECTION'),
			width: '50vw',
			breakpoints: { '1120px' : '95vw' },
			contentStyle: { overflow: 'auto' },
			data: {
				sectionId: this.section.Id
			}
		});
	}

	eliminaSezione(): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('DELETE_HELP_SECTION'),
			message: this.translate.instant('DELETE_HELP_SECTION_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(HelpActions.deleteHelpSection({sectionId: this.section.Id}));
			},
			reject: () => {
			}
		});
	}

	ordinaSottosezioni(): void {
		this.ref = this.dialogService.open(HelperOrderSubSectionDialogComponent, {
			header: this.translate.instant('REORDER_SUBSECTIONS'),
			// resizable: true,
			contentStyle: { overflow: 'auto' },
			data: {
				sectionId: this.section.Id
			}
		});
	}

	aggiungiSottosezioni(): void {
		this.ref = this.dialogService.open(HelperAddSubSectionDialogComponent, {
			header: this.translate.instant('ADD_SUBSECTION'),
			width: '50vw',
			breakpoints: { '1120px' : '95vw' },
			// resizable: true,
			contentStyle: { overflow: 'auto' },
			data: {
				sectionId: this.section.Id
			}
		});
	}

	accordionAction(): void {
		const listaFrames = document.getElementsByTagName('iframe');

		for (let index = 0; index <= listaFrames.length; index++) {
			if (listaFrames[index]!== undefined){
				const iframe = listaFrames[index].contentWindow;
				iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			}
		}
	}

	// Accordion Header Tab
	aggiungiRiga(subsectionData: SubSectionData): void {
		this.ref = this.dialogService.open(HelperAddRowDialogComponent, {
			header: this.translate.instant('ADD_ROW'),
			width: '50vw',
			breakpoints: { '1120px' : '95vw' },
			// resizable: true,
			contentStyle: { overflow: 'auto' },
			data: {
			subsectionId: subsectionData.Id
			},
		});
	}

	riordinaRow(subsectionData: SubSectionData): void {
		this.ref = this.dialogService.open(HelperOrderRowDialogComponent, {
			header: this.translate.instant('REORDER_ROWS'),
			// resizable: true,
			contentStyle: { overflow: 'auto' },
			data: {
				subsectionId: subsectionData.Id
			}
		});
}

	modificaSottosezione(subsectionData: SubSectionData): void {
		this.ref = this.dialogService.open(HelperAddSubSectionDialogComponent, {
			header: this.translate.instant('EDIT_SUBSECTION'),
			width: '50vw',
			breakpoints: { '1120px' : '95vw' },
			// resizable: true,
			contentStyle: { overflow: 'auto' },
			data: {
				subsectionId: subsectionData.Id
			}
		});
	}

eliminaSottosezione(subsectionData: SubSectionData): void {
		this.acceptButtonStyle = "p-button-danger";
		this.rejectButtonStyle = "p-button-secondary";
		this.confirmationService.confirm({
			header: this.translate.instant('DELETE_HELP_SUBSECTION'),
			message: this.translate.instant('DELETE_HELP_SUBSECTION_WARNING'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => {
				this.store.dispatch(HelpActions.deleteHelpSubSection({subsectionId: subsectionData.Id}));
			},
			reject: () => {
			}
		});
	}
}
